export default __webpack_public_path__ + "static/media/ic_table_settings.d2390833.svg";